document.addEventListener("DOMContentLoaded", function () {
  var stepsGrid = document.getElementById("steps-grid");
  if (!stepsGrid) return;

  var USERS = window.__usersOptions || [];
  var stepPrefix = stepsGrid.dataset.stepPrefix;

  // ============================================================
  // Utility
  // ============================================================

  function findUser(id) {
    return USERS.find(function (u) { return u[1] === id; });
  }


  function uniqueIndex() {
    return Date.now() + "" + Math.floor(Math.random() * 1000);
  }

  // ============================================================
  // Step management
  // ============================================================

  function getStepItems() {
    return Array.from(stepsGrid.querySelectorAll("[data-step-item]"));
  }

  function getVisibleSteps() {
    return getStepItems().filter(function (el) {
      return el.style.display !== "none";
    });
  }

  function renumberSteps() {
    var visible = getVisibleSteps();
    visible.forEach(function (el, idx) {
      var no = idx + 1;
      var span = el.querySelector(".step-no");
      if (span) span.textContent = no;
      var hidden = el.querySelector("input[name*='[step_number]']");
      if (hidden) hidden.value = no;
    });
    updateStepRemoveButtons();
  }

  function updateStepRemoveButtons() {
    var visible = getVisibleSteps();
    visible.forEach(function (el) {
      var btn = el.querySelector(".step-remove-btn");
      if (btn) btn.style.display = visible.length <= 1 ? "none" : "";
    });
  }

  function addStep() {
    var idx = uniqueIndex();
    var prefix = stepPrefix + "[" + idx + "]";
    var approverPrefix = prefix + "[workflow_step_approvers_attributes]";

    var step = document.createElement("div");
    step.dataset.stepItem = "";
    step.dataset.stepPrefix = prefix;
    step.style.cssText = "min-width:220px; padding:1em; background:#f9f9f9; border-radius:6px; border:1px solid #e8e8e8; display:flex; flex-direction:column; flex-shrink:0;";

    step.innerHTML =
      '<input type="hidden" name="' + prefix + '[step_number]" value="">' +
      '<input type="hidden" name="' + prefix + '[approval_type]" value="or">' +
      '<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:0.6em;">' +
        '<strong class="step-label" style="font-size:0.9em;">ステップ <span class="step-no"></span></strong>' +
        '<button type="button" class="step-remove-btn" title="このステップを削除" aria-label="このステップを削除" style="cursor:pointer; color:#aaa; font-size:0.85em; line-height:1; background:none; border:none; padding:0;">×</button>' +
      '</div>' +
      '<div class="step-approvers" data-approver-prefix="' + approverPrefix + '"></div>' +
      '<button type="button" class="ui mini blue basic button add-approver-btn" style="margin-top:auto; align-self:flex-start;"><i class="plus icon"></i> 承認者を追加</button>';

    stepsGrid.appendChild(step);
    bindStepEvents(step);
    addApprover(step);
    renumberSteps();
  }

  function removeStep(stepEl) {
    var destroyInput = stepEl.querySelector(".step-destroy");
    if (destroyInput) {
      destroyInput.value = "1";
      stepEl.style.display = "none";
    } else {
      stepEl.remove();
    }
    renumberSteps();
  }

  // ============================================================
  // Approver management
  // ============================================================

  function getVisibleApprovers(stepEl) {
    var container = stepEl.querySelector(".step-approvers");
    return Array.from(container.querySelectorAll(".approver-row")).filter(function (el) {
      return el.style.display !== "none";
    });
  }

  function getSelectedUserIds(stepEl) {
    var ids = [];
    getVisibleApprovers(stepEl).forEach(function (row) {
      var input = row.querySelector(".approver-user-id");
      if (input && input.value) ids.push(parseInt(input.value, 10));
    });
    return ids;
  }

  function addApprover(stepEl) {
    var container = stepEl.querySelector(".step-approvers");
    var approverPrefix = container.dataset.approverPrefix;
    var idx = uniqueIndex();
    var name = approverPrefix + "[" + idx + "][user_id]";

    var row = document.createElement("div");
    row.className = "approver-row";
    row.style.marginBottom = "4px";
    row.innerHTML = '<input type="hidden" name="' + name + '" value="" class="approver-user-id">';

    container.appendChild(row);
    initApproverSearch(row);
  }

  function removeApprover(row) {
    var destroyInput = row.querySelector(".approver-destroy");
    if (destroyInput) {
      destroyInput.value = "1";
      row.style.display = "none";
    } else {
      row.remove();
    }
  }

  // ============================================================
  // Approver search UI
  // ============================================================

  function initApproverSearch(row) {
    if (row.dataset.searchInit) return;
    row.dataset.searchInit = "1";

    var userIdInput = row.querySelector(".approver-user-id");
    var stepEl = row.closest("[data-step-item]");

    var wrapper = document.createElement("div");
    wrapper.className = "approver-search-wrapper";
    wrapper.style.cssText = "position:relative; display:block;";

    // Selected tag
    var tag = document.createElement("span");
    tag.style.cssText = "display:none; align-items:center; justify-content:space-between; padding:3px 8px; background:#e8e8e8; border-radius:3px; font-size:0.9em; width:100%; box-sizing:border-box;";

    var tagName = document.createElement("span");
    tag.appendChild(tagName);

    var tagX = document.createElement("span");
    tagX.textContent = "×";
    tagX.style.cssText = "cursor:pointer; font-weight:bold; color:#999; margin-left:4px;";
    tag.appendChild(tagX);
    wrapper.appendChild(tag);

    // Search input
    var input = document.createElement("input");
    input.type = "text";
    input.placeholder = "ユーザー名で検索...";
    input.style.cssText = "width:100%; padding:4px 8px; border:1px solid #ddd; border-radius:4px; font-size:0.85em; box-sizing:border-box;";
    wrapper.appendChild(input);

    // Dropdown
    var dropdown = document.createElement("div");
    dropdown.style.cssText = "position:absolute; left:0; width:280px; max-height:180px; overflow-y:auto; background:#fff; border:1px solid #ddd; border-top:none; border-radius:0 0 4px 4px; z-index:10; display:none; box-shadow:0 2px 8px rgba(0,0,0,0.1);";
    wrapper.appendChild(dropdown);

    row.appendChild(wrapper);

    // Show existing value
    if (userIdInput.value) {
      var existingUser = findUser(parseInt(userIdInput.value, 10));
      if (existingUser) {
        tagName.textContent = existingUser[0] + " (ID:" + existingUser[1] + ")";
        tag.style.display = "inline-flex";
        input.style.display = "none";
      }
    }

    function showSelected(u) {
      userIdInput.value = u[1];
      tagName.textContent = u[0] + " (ID:" + u[1] + ")";
      tag.style.display = "inline-flex";
      input.style.display = "none";
      input.value = "";
      dropdown.style.display = "none";
    }

    function renderDropdown(query) {
      dropdown.innerHTML = "";
      var q = query.toLowerCase();
      var selectedIds = getSelectedUserIds(stepEl);
      var currentVal = userIdInput.value ? parseInt(userIdInput.value, 10) : null;

      var matches = USERS.filter(function (u) {
        if (u[0].toLowerCase().indexOf(q) === -1) return false;
        // Exclude users already selected in this step (except current)
        if (u[1] !== currentVal && selectedIds.indexOf(u[1]) !== -1) return false;
        return true;
      });

      if (matches.length === 0) {
        dropdown.style.display = "none";
        return;
      }

      matches.slice(0, 20).forEach(function (u) {
        var item = document.createElement("div");
        item.textContent = u[0] + " (ID:" + u[1] + "/" + (u[2] || "") + ")";
        item.style.cssText = "padding:6px 10px; cursor:pointer; font-size:0.9em;";
        item.addEventListener("mouseenter", function () { item.style.background = "#f0f0f0"; });
        item.addEventListener("mouseleave", function () { item.style.background = ""; });
        item.addEventListener("mousedown", function (e) {
          e.preventDefault();
          showSelected(u);
        });
        dropdown.appendChild(item);
      });
      dropdown.style.display = "";
    }

    input.addEventListener("input", function () {
      if (this.value.length > 0) renderDropdown(this.value);
      else dropdown.style.display = "none";
    });

    input.addEventListener("focus", function () {
      if (this.value.length > 0) renderDropdown(this.value);
    });

    input.addEventListener("blur", function () {
      setTimeout(function () { dropdown.style.display = "none"; }, 150);
    });

    tagX.addEventListener("click", function () {
      removeApprover(row);
    });
  }

  // ============================================================
  // Event binding
  // ============================================================

  function bindStepEvents(stepEl) {
    stepEl.querySelector(".step-remove-btn").addEventListener("click", function () {
      removeStep(stepEl);
    });

    stepEl.querySelector(".add-approver-btn").addEventListener("click", function () {
      addApprover(stepEl);
    });

    stepEl.querySelectorAll(".approver-row").forEach(initApproverSearch);
  }

  // ============================================================
  // Init
  // ============================================================

  document.getElementById("add-step-btn").addEventListener("click", addStep);

  getStepItems().forEach(bindStepEvents);
  renumberSteps();
});
